import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, User } from "@/v2/types";

export default async function FindAllUser({
    skip,
    limit,
    search,
}: {
    skip?: number;
    limit?: number;
    search?: string;
}): Promise<{ data: User[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/users",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
        },
    });
    return res.data;
}
